import { Component, Input } from "@angular/core";

import { ListPickerItem } from "./list-picker-item";

@Component({
  selector: "onsip-list-picker-view",
  templateUrl: "list-picker-view.component.html",
  styleUrls: ["list-picker.component.scss"],
  standalone: false
})
export class ListPickerViewComponent {
  /** The readable name for a list item (plural) to be used in display text */
  @Input() itemNamePlural = "";
  /** The items in the list */
  @Input() itemList: Array<ListPickerItem> = [];
  /** Show avatar for accompanied item */
  @Input() showAvatar = true;
}
